import React from "react";

export const TableHeader: React.FC<{ isFirst?: boolean, isLast?: boolean }> = ({ isFirst, children, isLast }) => {
  return <div className={`py-3 px-4 whitespace-nowrap flex items-center bg-fg-gray-surface-light h-12 ${isFirst ? 'rounded-tl-lg' : isLast ? 'rounded-tr-lg' : ''}`}>
    {children}
  </div>
}